// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
    display: flex;
    min-width: 100%;
    min-height: 100%;
    background-color: white;
  }
  
  
  @media (max-width:600px){
    .dashboard{
      min-height: 90%;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;;EAGA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,mBAAmB;IACrB;EACF","sourcesContent":[".dashboard {\n    display: flex;\n    min-width: 100%;\n    min-height: 100%;\n    background-color: white;\n  }\n  \n  \n  @media (max-width:600px){\n    .dashboard{\n      min-height: 90%;\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
